import American from '@wh/svg-icons/American';
import Chat from '@wh/svg-icons/Chat';
import Contactus from '@wh/svg-icons/Contactus';
import Decimal from '@wh/svg-icons/Decimal';
import Email from '@wh/svg-icons/Email';
import Feedback from '@wh/svg-icons/Feedback';
import Fraction from '@wh/svg-icons/Fraction';
import Greyhounds from '@wh/svg-icons/Greyhounds';
import HelpCircle from '@wh/svg-icons/HelpCircle';
import HorseRacing from '@wh/svg-icons/HorseRacing';
import Podcast from '@wh/svg-icons/Podcast';
import Radio from '@wh/svg-icons/Radio';
import Tv from '@wh/svg-icons/Tv';

const ICONS = {
  American,
  Chat,
  Contactus,
  Decimal,
  Email,
  Feedback,
  Fraction,
  Greyhounds,
  HelpCircle,
  HorseRacing,
  Podcast,
  Radio,
  Tv,
};

const svgIconsResolver = (name) => ICONS[name];

export default svgIconsResolver;
